import { Link } from "react-router-dom";

const EmptyState = ({ icon: Icon, title, message, actionLabel, actionTo, onAction }) => (
  <div className="dashboard-empty">
    {Icon && <Icon className="dashboard-empty__icon" aria-hidden="true" />}
    <h3 className="dashboard-empty__title">{title}</h3>
    {message && <p className="dashboard-empty__text">{message}</p>}
    {actionLabel && actionTo && (
      <Link to={actionTo} className="dashboard-btn dashboard-btn--primary">
        {actionLabel}
      </Link>
    )}
    {actionLabel && onAction && !actionTo && (
      <button type="button" className="dashboard-btn dashboard-btn--primary" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
